import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Form, InputNumber, Input, Button, Select, Row, Col } from "antd";
import {
  changeActiveStep,
  changeBasicNewTestDetails,
} from "../../../reducers/test";
import { SecurePost } from "../../../services/axiosCall";
import apis from "../../../services/Apis";
import "./newtest.css";
import "../../basic/login/login.css";
import {
  givenLevels,
  givenSchools,
  givenYears,
  paper,
  paper1,
  terms,
} from "../../common/constants";

const BasicTestForm = () => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const { newtestFormData } = useSelector((state) => state.test);
  const { subjectTableData } = useSelector((state) => state.admin);
  // console.log(subjectTableData);

  const [checkingNameStatus, setCheckingNameStatus] = useState("");

  const [level, setLevel] = useState("");
  const [exam, setExam] = useState("");
  const [school, setSchool] = useState("");
  const [term, setTerm] = useState("");
  const [year, setYear] = useState("");

  const selectedSubjectId = Form.useWatch("subjects", form);
  const [selectedPaperOptions, setSelectedPaperOptions] = useState([]);

  useEffect(() => {
    const selectedSubject = subjectTableData.find(
      (item) => item._id === selectedSubjectId
    );
    if (selectedSubject?.topic === "Mathematics") {
      setSelectedPaperOptions(paper);
    } else {
      setSelectedPaperOptions(paper1);
    }
  }, [selectedSubjectId, subjectTableData, paper, paper1]);

  const validateTestName = async (_, value) => {
    if (!value || value.length < 5) return Promise.resolve();
    setCheckingNameStatus("validating");
    try {
      const response = await SecurePost({
        url: apis.CHECK_TEST_NAME,
        data: { testname: value },
      });
      const { data } = response;
      if (data.success && !data.can_use) {
        setCheckingNameStatus("error");
        return Promise.reject("Another test exists with the same name.");
      } else {
        setCheckingNameStatus("success");
        return Promise.resolve();
      }
    } catch (error) {
      setCheckingNameStatus("success");
      return Promise.resolve();
    }
  };

  const handleFinish = (values) => {
    dispatch(
      changeBasicNewTestDetails({
        testType: values.type || "post-test",
        testTitle: values.title,
        testDuration: values.duration,
        OrganisationName: values.organisation,
        testSubject: values.subjects,
        level,
        exam,
        school,
        term,
        year,
      })
    );
    dispatch(changeActiveStep(1));
  };

  return (
    <div
      className="login-container"
      style={{ display: "flex", margin: "auto" }}
    >
      <div className="login-inner">
        <Form
          form={form}
          layout="vertical"
          onFinish={handleFinish}
          initialValues={{
            duration: newtestFormData.testDuration,
            subjects: newtestFormData.testSubject,
            title: newtestFormData.testTitle,
          }}
        >
          <Row>
            <Col span={24}>
              <Form.Item
                label="Test Title"
                name="title"
                hasFeedback
                validateStatus={checkingNameStatus}
                rules={[
                  { required: true, message: "Please give the test title" },
                  {
                    min: 5,
                    message: "Title should be at least 5 characters long",
                  },
                  { validator: validateTestName },
                ]}
              >
                <Input placeholder="Test Title" />
              </Form.Item>
            </Col>
          </Row>

          <Row
            gutter={[8, 8]}
            style={{ display: "flex", alignItems: "center" }}
          >
            <Col span={12}>
              <Form.Item
                label="Subjects"
                name="subjects"
                rules={[{ required: true, message: "Please select a subject" }]}
              >
                <Select placeholder="Select Subject" allowClear size="large">
                  {subjectTableData.map((item) => (
                    <Select.Option key={item._id} value={item._id}>
                      {item.topic}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item label="Level" required>
                <Select
                  showSearch 
                  placeholder="Select Level"
                  onChange={(value) => setLevel(value)}
                  size="large"
                >
                  {givenLevels.map((d) => (
                    <Select.Option key={d.value} value={d.value}>
                      {d.label}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>

          <Row
            gutter={[8, 8]}
            style={{ display: "flex", alignItems: "center" }}
          >
            <Col span={12}>
              <Form.Item label="Term" required>
                <Select
                  showSearch
                  placeholder="Select Term"
                  onChange={(value) => setTerm(value)}
                  size="large"
                >
                  {terms.map((d) => (
                    <Select.Option key={d.value} value={d.value}>
                      {d.label}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item label="School">
                <Select
                  showSearch
                  placeholder="Select School"
                  onChange={(value) => setSchool(value)}
                  size="large"
                >
                  {givenSchools.map((d) => (
                    <Select.Option key={d.value} value={d.value}>
                      {d.label}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>

          <Row
            gutter={[8, 8]}
            style={{ display: "flex", alignItems: "center" }}
          >
            <Col span={12}>
              <Form.Item
                label="Test Duration"
                name="duration"
                rules={[
                  { required: true, message: "Please give test duration" },
                ]}
              >
                <InputNumber
                  style={{ width: "100%" }}
                  placeholder="Test Duration"
                  min={15}
                  max={180}
                  size="large"
                />
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item label="Paper">
                <Select
                  showSearch
                  placeholder="Select Paper"
                  options={selectedPaperOptions}
                  size="large"
                  onChange={(value) => setExam(value)}
                />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={[8, 8]}>
            <Col span={24}>
              <Form.Item label="Year">
                <Select
                  showSearch
                  placeholder="Select Year"
                  onChange={(value) => setYear(value)}
                >
                  {givenYears.map((d) => (
                    <Select.Option key={d.value} value={d.value}>
                      {d.label}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>

          <Form.Item>
            <Button type="primary" htmlType="submit" block>
              Next
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
};

export default BasicTestForm;
